import { IList } from "types/gaiaComponents/list";
import "./list.css";

export const List = (props: IList) => {
    return (
        <ul className={`ga-list${props.className ? ` ${props.className}` : ""}`}
            aria-label={props.ariaLabel}
            data-cy={props.dataCy}>
            {props.children}
        </ul>
    );
}
